import Component from 'inferno-component';
import debounce from 'debounce';
import { connect } from 'inferno-redux';

import Logo from '../assets/images/logo';
import SearchIcon from '../assets/images/search-icon';

import { getWords, resetSearchResult } from '../redux/words';
import { logoutUserSession } from '../redux/auth';

import SearchInput from '../components/SearchInput';

function mapStateToProps(state) {
  return {
    searchTerm: state.words.searchTerm,
    searchResults: state.words.searchResults,
    userIsLoggedIn: state.auth.userIsLoggedIn,
  };
}

class HeaderNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      searchResults: null,
    };
  }

  componentDidMount() {
    const { searchTerm } = this.state;
    if (searchTerm) {
      return this.props.getWords(searchTerm).then(searchResults => {
        this.setState({
          searchResults,
        });
      });
    }
  }

  updateSearch = debounce(e => {
    const { value } = e.target;
    const sanitizedSearchTerm = value.replace(/[^\w\s]/gi, '');
    this.setState({ searchTerm: sanitizedSearchTerm });
    if (!value) {
      return this.props.resetSearchResult();
    }

    return this.props.getWords(sanitizedSearchTerm).then(searchResults => {
      this.setState({
        searchResults,
      });
    });
  }, 200);

  handleSearchClick = e => {
    this.setState({
      showMobileMenu: false,
      showMobileSearch: !this.state.showMobileSearch,
    });
  };

  handleMenuClick = e => {
    this.setState({
      showMobileSearch: false,
      showMobileMenu: !this.state.showMobileMenu,
    });
  };

  logoutCurrentUser = () => {
    if (this.props.userIsLoggedIn) {
      this.props
        .logoutUserSession()
        .then(() => {
          // Removes user display name in local storage
          window.localStorage.removeItem('manomanoDisplayName');
          // Refreshing the page, otherwise the search result is cached
          //   when the user is redirected to the home page
          return window.location.replace(window.location.origin);
        })
        .catch(err => {});
    }
    return window.location.replace(window.location.origin);
  };

  render() {
    const navItems = [
      { name: 'Word of the Day', link: '/word-of-the-day' },
      { name: 'Flashcards', link: '/flashcards' },
      { name: 'About', link: '/about' },
    ];
    const mobileOnlyNavItems = [
      { name: 'Word of the Day', link: '/word-of-the-day' },
      { name: 'Flashcards', link: '/flashcards' },
      { name: 'Resources', link: '/resources' },
      { name: 'About', link: '/about' },
      { name: 'Mission', link: '/mission' },
      { name: 'Feedback', link: '/feedback' },
    ];
    const {
      sideContent,
      hideSmallSearchBar,
      mode,
      pageTitle,
      showLargeSearchBar,
      userIsLoggedIn,
    } = this.props;

    const manomanoDisplayName = window.localStorage.getItem(
      'manomanoDisplayName'
    );

    const loginComponent = userIsLoggedIn ? (
      <a href="/account">Aloha e {manomanoDisplayName}</a>
    ) : (
      <a href="/login">Log In/Sign Up</a>
    );

    const logoutComponent = userIsLoggedIn ? (
      <button onClick={this.logoutCurrentUser}>Logout</button>
    ) : (
      false
    );

    const mobileMenuClass = this.state.showMobileMenu
      ? 'header__menu-list'
      : 'header__menu-list header__menu-list--hide';
    const mobileMenuIconClass = this.state.showMobileMenu
      ? 'header__menu-icon header__menu-icon--open'
      : 'header__menu-icon';
    const mobileSearchClass = this.state.showMobileSearch
      ? 'header__search-bar'
      : 'header__search-bar header__search-bar--hide';

    if (mode === 'light') {
      return (
        <div className="header">
          <div className="header__nav-container">
            <div className="header__top-bar">
              <div
                className={mobileMenuIconClass}
                onClick={this.handleMenuClick}
              />
              <a href="/">
                <Logo />
              </a>
              <div
                className="header__search-icon"
                onClick={this.handleSearchClick}
              >
                <SearchIcon />
              </div>
            </div>
            <ul className={`${mobileMenuClass} header__menu-list--light`}>
              {navItems.map(navItem => {
                return (
                  <li className="header__menu-item desktop_only">
                    <a href={navItem.link}>{navItem.name}</a>
                  </li>
                );
              })}
              {mobileOnlyNavItems.map(navItem => {
                return (
                  <li className="header__menu-item mobile_only">
                    <a href={navItem.link}>{navItem.name}</a>
                  </li>
                );
              })}
              <li className="header__menu-item">{loginComponent}</li>
              {logoutComponent && (
                <li className="header__menu-item">{logoutComponent}</li>
              )}
            </ul>
            <div className={`${mobileSearchClass} header__search-bar--light`}>
              <SearchInput searchClassName="home-page" />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="header header--dark">
          <div className="header__nav-container">
            <div className="header__top-bar">
              <div
                className={`${mobileMenuIconClass} header__menu-icon--dark`}
                onClick={this.handleMenuClick}
              />
              <a href="/">
                <Logo fill="white" />
              </a>
              <div
                className="header__search-icon"
                onClick={this.handleSearchClick}
              >
                <SearchIcon fill="white" />
              </div>
            </div>
            <ul className={`${mobileMenuClass} header__menu-list--dark`}>
              {navItems.map(navItem => {
                return (
                  <li className="header__menu-item header__menu-item--dark desktop_only">
                    <a href={navItem.link}>{navItem.name}</a>
                  </li>
                );
              })}
              {mobileOnlyNavItems.map(navItem => {
                return (
                  <li className="header__menu-item header__menu-item--dark mobile_only">
                    <a href={navItem.link}>{navItem.name}</a>
                  </li>
                );
              })}
              <li className="header__menu-item header__menu-item--dark">
                {loginComponent}
              </li>
              {logoutComponent && (
                <li className="header__menu-item header__menu-item--dark">
                  {logoutComponent}
                </li>
              )}
            </ul>
            <div className={`${mobileSearchClass} header__search-bar`}>
              {!hideSmallSearchBar && (
                <SearchInput searchClassName="header-nav" iconColor="#333" />
              )}
            </div>
          </div>
          {(pageTitle || showLargeSearchBar || sideContent) && (
            <div className="header__details-container">
              {pageTitle && <h1 className="page__title">{pageTitle}</h1>}
              {showLargeSearchBar && (
                <SearchInput searchClassName="definition-preview" />
              )}
              {sideContent && <div className="side-content">{sideContent}</div>}
            </div>
          )}
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, {
  getWords,
  logoutUserSession,
  resetSearchResult,
})(HeaderNav);



// WEBPACK FOOTER //
// ./src/components/HeaderNav.js